import type { DiretoriaKpiTone } from '@/lib/diretoriaKpiTone';

export type DiretoriaChartKind =
  | 'line'
  | 'bar'
  | 'barHorizontal'
  | 'barGrouped'
  | 'pie'
  | 'none';
export type DiretoriaDataSource = 'erp' | 'cobranca' | 'oficina';

export interface DiretoriaKpi {
  label: string;
  value: string;
  hint?: string;
  tone?: DiretoriaKpiTone;
}

export interface DiretoriaSeriesPoint {
  name: string;
  valor: number;
  valor2?: number;
}

export interface DiretoriaPieSlice {
  name: string;
  value: number;
}

export interface DiretoriaSeriesLabels {
  valor: string;
  valor2?: string;
}

export interface DiretoriaIndicator {
  id: string;
  title: string;
  shortDescription: string;
  primaryKpiIndex?: number;
  kpis: DiretoriaKpi[];
  chartKind: DiretoriaChartKind;
  /** Título curto acima do gráfico no modal de análise. */
  chartTitle?: string;
  series?: DiretoriaSeriesPoint[];
  pieData?: DiretoriaPieSlice[];
  barSeriesKey?: 'valor' | 'valor2';
  seriesLabels?: DiretoriaSeriesLabels;
  tableHeaders: string[];
  tableRows: string[][];
  footnote: string;
  querySql?: string;
  dataSource: DiretoriaDataSource;
  hasData?: boolean;
}

export const DIRETORIA_MES_LABELS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'] as const;

export const EMPTY_AGING_CHART: DiretoriaSeriesPoint[] = [
  { name: '1–2 dias', valor: 0, valor2: 0 },
  { name: '3–6 dias', valor: 0, valor2: 0 },
  { name: '7+ dias', valor: 0, valor2: 0 },
];

export const EMPTY_EVOLUCAO_CHART: DiretoriaSeriesPoint[] = DIRETORIA_MES_LABELS.map((name) => ({
  name,
  valor: 0,
  valor2: 0,
}));
